/* ==========================================================================
   Oh!My Snacks · Loja (catálogo) — comportamento da versão nova
   --------------------------------------------------------------------------
   Cinco coisas:
     1. filtro e ordenação sem recarregar a página, pedindo a secção à Shopify
     2. «ver mais» que ACRESCENTA, em vez de navegar para a página seguinte
     3. o botão da ficha que vira contador quando o snack entra na seleção
     4. a barra da seleção, que lê o carrinho de verdade
     5. a gaveta das categorias, que no telemóvel toma o lugar da fita

   O que muda em relação ao `oms-loja.js` que está no ar:
   · O «ver mais» acrescentava? Não: navegava para `?page=2`, o que levava a
     pessoa de volta ao topo da página e voltava a mostrar-lhe a cabeça. Agora
     acrescenta, e a seguir a cada acrescento volta a empurrar os esgotados para
     o fim — o que desfaz a única ressalva da alteração de 2026-09-13, a cauda
     de esgotados a meio da grelha.
   · A fita NÃO é substituída quando se filtra, nem se mexe ao clicar. As
     contagens de uma categoria não mudam por se escolher outra do mesmo grupo;
     só o anel de «actual» muda de sítio, e a fita fica parada onde estava.
   · As rotas do carrinho vêm do Liquid, em `routes.*`. Um `/cart/add.js`
     escrito à mão não leva prefixo de mercado e manda a pessoa para o carrinho
     inglês (CLAUDE.md, corrigido no `related-products.liquid` a 2026-09-14).
   ========================================================================== */
(function () {
  'use strict';

  var raiz = document.querySelector('[data-section-id]');
  if (!raiz) return;

  var T = {};
  try { T = JSON.parse(raiz.querySelector('[data-loja-textos]').textContent); } catch (e) { return; }

  var secao = raiz.dataset.sectionId;
  var fita = raiz.querySelector('.loja-fita');
  var pista = raiz.querySelector('.loja-fita .pista');
  var barra = raiz.querySelector('.loja-barra');
  var conta = raiz.querySelector('.loja-barra .conta');
  var ordem = raiz.querySelector('.loja-ordem select');
  var grelha = raiz.querySelector('[data-grelha]');
  var caixaMais = raiz.querySelector('[data-mais-caixa]');
  var abrir = raiz.querySelector('[data-folha-abrir]');
  var folha = raiz.querySelector('[data-folha]');
  var selecao = raiz.querySelector('[data-selecao]');
  var mosaicos = selecao && selecao.querySelector('[data-mosaicos]');
  var linha = selecao && selecao.querySelector('[data-linha]');
  var sub = selecao && selecao.querySelector('[data-sub]');

  /* DOIS ESTADOS, E A DIFERENÇA ENTRE ELES É O QUE FAZ O CONTADOR RESPONDER.
     `naLoja` é o que o `/cart.js` diz, com as chaves de linha e os preços.
     `carrinho` é o que a pessoa quer, e é dele que a barra e os contadores se
     desenham. Carregar no mais mexe no segundo e a loja fica a saber depois.

     A versão anterior tinha uma tranca (`aEscrever`) que DEITAVA FORA os toques
     enquanto havia uma escrita a caminho: carregar depressa no mais três vezes
     contava uma. Levantado pelo Júlio a 2026-09-15 («deverias permitir pôr a
     quantidade em cesto»). Agora nenhum toque se perde e vai uma escrita só. */
  var naLoja = new Map();
  var carrinho = new Map();
  var pendentes = new Map();   /* variante → { adiar, emCurso, repetir } */
  var ESPERA = 450;            /* o tempo que se dá a quem está a carregar no mais */

  var dinheiro = (function () {
    try {
      var f = new Intl.NumberFormat(T.lingua || 'pt-PT', { style: 'currency', currency: T.moeda || 'EUR' });
      return function (cents) { return f.format(cents / 100); };
    } catch (e) {
      return function (cents) { return (cents / 100).toFixed(2) + ' ' + (T.moeda || ''); };
    }
  })();

  /* ---------- 1. filtro, chip e ordenação ---------- */

  function ocupado(sim) {
    if (!grelha) return;
    grelha.setAttribute('aria-busy', sim ? 'true' : 'false');
  }

  function pedir(url) {
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return fetch(url + sep + 'section_id=' + encodeURIComponent(secao), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) { return r.text(); }).then(function (html) {
      return new DOMParser().parseFromString(html, 'text/html');
    });
  }

  function trocar(url, empurrar) {
    ocupado(true);
    return pedir(url).then(function (doc) {
      var nova = doc.querySelector('[data-grelha]');
      var novaConta = doc.querySelector('.loja-barra .conta');
      var novaCaixa = doc.querySelector('[data-mais-caixa]');
      if (nova && grelha) grelha.innerHTML = nova.innerHTML;
      if (novaConta && conta) conta.innerHTML = novaConta.innerHTML;
      if (novaCaixa && caixaMais) { caixaMais.replaceWith(novaCaixa); caixaMais = novaCaixa; }
      /* A fita fica onde está: só muda o anel. Os `href` das outras categorias
         mudam com o chip, portanto copiam-se do documento novo pelo valor. As duas
         cópias da lista, a da fita e a da gaveta, mudam juntas. */
      var novos = {};
      doc.querySelectorAll('.loja-fita .cat').forEach(function (c) {
        novos[c.dataset.cat] = { href: c.getAttribute('href'), actual: c.classList.contains('actual') };
      });
      raiz.querySelectorAll('.loja-fita .cat, .loja-folha .cat').forEach(function (c) {
        var n = novos[c.dataset.cat];
        if (!n) return;
        c.setAttribute('href', n.href);
        c.classList.toggle('actual', n.actual);
        if (n.actual) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current');
      });
      /* O botão da gaveta vem desenhado do servidor, com o nome da categoria. */
      var novoAbrir = doc.querySelector('[data-folha-abrir]');
      if (novoAbrir && abrir) { abrir.className = novoAbrir.className; abrir.innerHTML = novoAbrir.innerHTML; }
      if (empurrar) history.pushState({ oms: true, url: url }, '', url);
      marcarTudo();
      aCarregarTudo = false;
      carregarTudo();   /* a categoria nova pode ter mais do que uma página */
    }).catch(function () {
      window.location.href = url;
    }).finally(function () { ocupado(false); });
  }

  function subirAteABarra() {
    if (!barra) return;
    var topo = barra.getBoundingClientRect().top + window.scrollY - 52 - 16;
    if (window.scrollY > topo) window.scrollTo({ top: topo, behavior: 'smooth' });
  }

  function escolher(cat) {
    return trocar(cat.getAttribute('href'), true).then(subirAteABarra);
  }

  if (fita) {
    fita.addEventListener('click', function (e) {
      var cat = e.target.closest('.cat');
      if (!cat) return;
      e.preventDefault();
      /* A fita NÃO se mexe ao clicar. Havia aqui um scroll que trazia o mosaico
         escolhido para a aresta esquerda, e o efeito era a fita inteira a fugir
         para o lado à frente de quem clicou. Levantado pelo Júlio a 2026-09-15.
         O mosaico escolhido já se identifica pelo anel; não precisa de se mover. */
      escolher(cat);
    });
    /* As setas. Rolam cerca de três quartos do que se vê, que é o suficiente
       para a fita avançar sem perder o fio de onde se estava. Escondem-se nas
       pontas pelas mesmas classes que já governam o esbatimento da máscara. */
    fita.addEventListener('click', function (e) {
      var seta = e.target.closest('[data-seta]');
      if (!seta || !pista) return;
      e.preventDefault();
      e.stopPropagation();
      pista.scrollBy({ left: Number(seta.dataset.seta) * pista.clientWidth * 0.75, behavior: 'smooth' });
    }, true);

    if (pista) {
      var mascara = function () {
        var x = pista.scrollLeft, max = pista.scrollWidth - pista.clientWidth;
        fita.classList.toggle('rolou', x > 8);
        fita.classList.toggle('fim', max - x < 8);
        /* A barra de rolamento da fita, no telemóvel. A largura do cursor é a fatia
           visível e a posição é o quanto já se rolou. A classe só entra quando há
           mesmo para onde rolar: sem ela o CSS não desenha a barra, e assim uma loja
           com poucas categorias não mostra um indicador que não indica nada. */
        fita.classList.toggle('rola', max > 4);
        if (max > 4) {
          fita.style.setProperty('--rolo-w', Math.max(.12, pista.clientWidth / pista.scrollWidth));
          fita.style.setProperty('--rolo-x', Math.min(1, Math.max(0, x / max)));
        }
      };
      pista.addEventListener('scroll', mascara, { passive: true });
      addEventListener('resize', mascara);
      mascara();
      /* o mosaico activo entra no ecrã ao carregar a página */
      var posto = pista.querySelector('.cat.actual');
      if (posto && posto.offsetLeft > pista.clientWidth * 0.6) {
        pista.scrollLeft = posto.offsetLeft - 24;
        mascara();
      }
    }
  }

  if (ordem) {
    ordem.closest('form').addEventListener('submit', function (e) { e.preventDefault(); });
    ordem.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', ordem.value);
      trocar(url.pathname + url.search, true);
    });
  }

  addEventListener('popstate', function (e) {
    if (e.state && e.state.oms) trocar(e.state.url, false);
  });

  /* ---------- a gaveta das categorias, no telemóvel ----------
     Abaixo dos 900 px a fita dá lugar a um botão, que abre uma gaveta de baixo com
     as dezasseis categorias à vista de uma vez (Júlio, 2026-09-24: o CEO não as
     queria escondidas numa fita que rola para o lado).

     É um `<dialog>`, e o `showModal()` dá sem código nosso a camada de topo, o foco
     preso lá dentro, o Esc e o resto da página inerte. O que é nosso é o movimento,
     o arrastar a pega para fechar e o bloqueio do rolamento por trás, que o
     `<dialog>` não faz e sem o qual a página rolava debaixo do dedo no iOS.

     Escolher uma categoria fecha a gaveta e pede a grelha AO MESMO TEMPO: a folha
     leva um terço de segundo a descer, e é esse o tempo que o pedido demora. Quem
     a vê sair encontra a grelha já trocada, ou a acabar de trocar. */
  if (folha && abrir && folha.showModal) {
    var caixa = folha.querySelector('.folha');
    var veu = folha.querySelector('.veu');
    var pega = folha.querySelector('[data-folha-pega]');
    var titulo = folha.querySelector('h2');
    var aFechar = null;
    var fechando = false;
    var teclado = false;

    /* O FOCO DEPENDE DE COMO SE ABRIU. Por teclado vai para a categoria em que se
       está, que é por onde quem navega assim quer começar, e volta ao botão no fim.
       Ao toque vai para a própria folha, que não desenha anel: o WebKit põe o anel
       terracota em qualquer foco movido por código, e na primeira volta desta
       gaveta, a 2026-09-24, o «Todos» abria com ele à volta e o botão fechava com
       ele. O `detail` de um clique é 0 quando vem do Enter ou do espaço. */
    var abrirFolha = function (porTeclado) {
      if (folha.open) return;
      teclado = porTeclado;
      folha.classList.remove('aberta');
      folha.showModal();
      document.documentElement.style.overflow = 'hidden';
      abrir.setAttribute('aria-expanded', 'true');
      var posto = teclado ? (folha.querySelector('.cat.actual') || folha.querySelector('.cat')) : caixa;
      if (posto) posto.focus({ preventScroll: true });
      folha.scrollTop = 0;
      /* Dois frames: no primeiro a folha pinta-se em baixo, no segundo começa a subir.
         Com um só, o browser junta os dois estados e ela aparece já no sítio. */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { if (folha.open && !fechando) folha.classList.add('aberta'); });
      });
    };

    /* Um fecho de cada vez: dois toques no véu durante a descida não registam o fim
       duas vezes. */
    var fecharFolha = function () {
      if (!folha.open || fechando) return;
      fechando = true;
      folha.classList.remove('aberta');
      abrir.setAttribute('aria-expanded', 'false');
      var fim = function () {
        if (!fechando) return;
        fechando = false;
        clearTimeout(aFechar);
        caixa.removeEventListener('transitionend', aoFim);
        folha.close();
        document.documentElement.style.overflow = '';
        if (teclado) abrir.focus({ preventScroll: true });
      };
      var aoFim = function (e) { if (e.target === caixa) fim(); };
      caixa.addEventListener('transitionend', aoFim);
      aFechar = setTimeout(fim, 480);   /* rede, para quando não há transição a acabar */
    };

    /* O botão diz logo a categoria escolhida, sem esperar pela resposta da loja.
       Quando ela chega, o `trocar` substitui-o pelo que o servidor desenhou. */
    var marcarEscolha = function (cat) {
      var valor = cat.dataset.cat;
      raiz.querySelectorAll('.loja-fita .cat, .loja-folha .cat').forEach(function (c) {
        var sim = c.dataset.cat === valor;
        c.classList.toggle('actual', sim);
        if (sim) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current');
      });
      var rotulo = abrir.querySelector('.rotulo');
      if (!rotulo || !titulo) return;
      var base = titulo.textContent.trim();
      var nome = cat.querySelector('.nome');
      abrir.classList.toggle('filtrado', !!valor);
      rotulo.textContent = '';
      if (valor && nome) {
        var voz = document.createElement('span');
        voz.className = 'so-voz';
        voz.textContent = base + ': ';
        rotulo.appendChild(voz);
        rotulo.appendChild(document.createTextNode(nome.textContent.trim()));
      } else {
        rotulo.textContent = base;
      }
    };

    abrir.addEventListener('click', function (e) { abrirFolha(e.detail === 0); });

    /* O `<dialog>` NUNCA ROLA. O CSS recorta-o com `overflow: clip`, que não se deixa
       rolar; isto é a rede para os browsers que não conhecem `clip` e ficam com o
       `hidden`, que se deixa. Sem ela, o foco posto na folha enquanto ela ainda vem
       de baixo rolava o `<dialog>` por dentro, e a folha saltava para cima antes de
       cair para o sítio. */
    folha.addEventListener('scroll', function () { if (folha.scrollTop) folha.scrollTop = 0; });

    folha.addEventListener('cancel', function (e) { e.preventDefault(); fecharFolha(); });

    folha.addEventListener('click', function (e) {
      if (e.target.closest('[data-folha-fechar]')) { fecharFolha(); return; }
      var cat = e.target.closest('.cat');
      if (!cat) return;
      e.preventDefault();
      if (cat.classList.contains('actual')) { fecharFolha(); return; }
      marcarEscolha(cat);
      fecharFolha();
      escolher(cat);
    });

    /* Arrastar a pega para baixo fecha, como numa folha do iOS. Fecha se passar dos
       90 px ou se o gesto for rápido, que é como o dedo diz «fora»; se não, a folha
       volta ao sítio. Para cima não anda: não há mais folha para mostrar. */
    var arr = null;
    pega.addEventListener('pointerdown', function (e) {
      if (e.target.closest('[data-folha-fechar]') || !folha.classList.contains('aberta')) return;
      arr = { id: e.pointerId, y: e.clientY, t: e.timeStamp, dy: 0, v: 0 };
      pega.setPointerCapture(e.pointerId);
      folha.classList.add('arrasto');
    });
    pega.addEventListener('pointermove', function (e) {
      if (!arr || e.pointerId !== arr.id) return;
      var dy = Math.max(0, e.clientY - arr.y);
      arr.v = (dy - arr.dy) / Math.max(1, e.timeStamp - arr.t);
      arr.dy = dy;
      arr.t = e.timeStamp;
      caixa.style.transform = 'translateY(' + dy + 'px)';
      veu.style.opacity = String(Math.max(0, 1 - dy / Math.max(1, caixa.offsetHeight)));
    });
    var largar = function (e) {
      if (!arr || e.pointerId !== arr.id) return;
      var sai = arr.dy > 90 || (arr.dy > 12 && arr.v > 0.5);
      arr = null;
      folha.classList.remove('arrasto');
      caixa.style.transform = '';
      veu.style.opacity = '';
      if (sai) fecharFolha();
    };
    pega.addEventListener('pointerup', largar);
    pega.addEventListener('pointercancel', largar);

    /* Se a janela passar a largura de computador com a gaveta aberta, a fita volta e
       a gaveta fecha-se: não há botão para a fechar a essa largura. */
    var largo = window.matchMedia('(min-width: 900px)');
    var mudou = function (m) { if (m.matches && folha.open) fecharFolha(); };
    if (largo.addEventListener) largo.addEventListener('change', mudou);
    else if (largo.addListener) largo.addListener(mudou);
  }

  /* ---------- 2. o resto do catálogo vem sozinho ----------
     O Liquid da Shopify não desenha mais de 50 produtos de uma vez. As páginas
     que faltam vêm por trás, logo a seguir à primeira pintura, e acrescentam-se:
     ninguém carrega em nada (Júlio, 2026-09-15). Para 117 snacks são duas
     chamadas, e as fotografias continuam a carregar só quando entram no ecrã.

     O `<a href="?page=N">` fica no HTML e não se toca: é por ele que um motor de
     busca chega aos produtos e é ele que funciona com o JavaScript desligado. Se
     uma das chamadas falhar, o link volta ao rótulo original e a pessoa pode
     carregar à mão — é a rede de segurança, não o caminho normal.

     O endereço NÃO muda para `?page=2` pelo caminho: quem está a ver a lista
     inteira não está na página dois, e guardar esse endereço dava outra coisa.

     Os esgotados já não se reordenam aqui. Quem os põe no fim é uma regra de CSS
     (`.ficha.esgotado { order: 1 }`), que vale para o catálogo todo e não por
     página. Antes, cada acrescento empurrava os esgotados para baixo à frente de
     quem estava a olhar. */

  var aCarregarTudo = false;

  function botaoMais() { return caixaMais && caixaMais.querySelector('[data-mais-btn]'); }

  function acrescentarPagina(url) {
    return pedir(url).then(function (doc) {
      var nova = doc.querySelector('[data-grelha]');
      if (nova && grelha) {
        Array.prototype.slice.call(nova.children).forEach(function (f) { grelha.appendChild(f); });
      }
      var novaCaixa = doc.querySelector('[data-mais-caixa]');
      if (novaCaixa && caixaMais) { caixaMais.replaceWith(novaCaixa); caixaMais = novaCaixa; }
      marcarTudo();
    });
  }

  function carregarTudo() {
    if (aCarregarTudo || !botaoMais()) return;
    aCarregarTudo = true;
    (function proxima() {
      var b = botaoMais();
      if (!b) { aCarregarTudo = false; return; }
      var rotulo = b.textContent;
      if (b.dataset.aCarregar) b.textContent = b.dataset.aCarregar;
      b.setAttribute('aria-busy', 'true');
      acrescentarPagina(b.getAttribute('href'))
        .then(proxima)
        .catch(function () {
          aCarregarTudo = false;
          var falhou = botaoMais();
          if (falhou) { falhou.textContent = rotulo; falhou.removeAttribute('aria-busy'); }
        });
    })();
  }

  /* Se o automático falhar, o link continua a ser um link. */
  raiz.addEventListener('click', function (e) {
    var bt = e.target.closest('[data-mais-btn]');
    if (!bt) return;
    e.preventDefault();
    carregarTudo();
  });

  /* ---------- 3 e 4. carrinho e seleção ---------- */

  function fichaDaVariante(id) {
    return raiz.querySelector('.ficha[data-variante="' + id + '"]');
  }

  /* O seletor está sempre à vista e diz duas coisas conforme o estado: antes de o
     snack entrar no carrinho é quantos vão entrar, depois é quantos lá estão. O
     número «a entrar» vive na própria ficha, porque é dela e não do carrinho. */
  function aEntrar(ficha) {
    return Math.min(99, Math.max(1, Number(ficha.dataset.entrar) || 1));
  }

  function marcar(ficha, n) {
    if (!ficha) return;
    var o = ficha.querySelector('output');
    if (n > 0) {
      ficha.classList.add('na-selecao');
      if (o) o.value = n;
    } else {
      ficha.classList.remove('na-selecao');
      if (o) o.value = aEntrar(ficha);
    }
  }

  function marcarTudo() {
    raiz.querySelectorAll('.ficha').forEach(function (f) {
      var l = carrinho.get(Number(f.dataset.variante));
      marcar(f, l ? l.quantidade : 0);
    });
  }

  /* O preço unitário em cêntimos: da própria ficha quando o snack está nesta
     página, e do carrinho para o que já lá estava. É o que permite ao total
     responder ao toque sem esperar pela loja. */
  function preco(variante, l) {
    var f = fichaDaVariante(variante);
    if (f && f.dataset.preco) return Number(f.dataset.preco) || 0;
    return (l && l.preco) || 0;
  }

  function pintarLocal() {
    var total = 0, unidades = 0;
    carrinho.forEach(function (l, variante) {
      unidades += l.quantidade;
      total += l.quantidade * preco(variante, l);
    });
    pintarSelecao(total, unidades);
    balao(unidades);
  }

  function pintarSelecao(total, unidades) {
    if (!selecao) return;
    mosaicos.innerHTML = '';
    var postos = 0;
    carrinho.forEach(function (l, variante) {
      if (postos >= 8) return;
      var f = fichaDaVariante(variante);
      var img = f && f.querySelector('.principal');
      var cel = document.createElement('span');
      /* Primeiro a imagem que a ficha já carregou, que não custa pedido nenhum;
         só depois a do carrinho, para o que não está nesta página. */
      var fonte = img ? (img.currentSrc || img.src)
                      : (l.imagem ? l.imagem + (l.imagem.indexOf('?') === -1 ? '?' : '&') + 'width=120' : null);
      if (fonte) {
        var nova = document.createElement('img');
        nova.src = fonte;
        nova.alt = '';
        cel.appendChild(nova);
      } else {
        cel.textContent = l.quantidade;
      }
      mosaicos.appendChild(cel);
      postos += 1;
    });
    if (carrinho.size > postos) {
      var mais = document.createElement('span');
      mais.textContent = '+' + (carrinho.size - postos);
      mosaicos.appendChild(mais);
    }
    var palavra = unidades === 1 ? T.snack : T.snacks;
    linha.innerHTML = '<b>' + unidades + ' ' + palavra + '</b> · ' + dinheiro(total);
    /* Sem limiar, esta linha não aparece: o Liquid só o manda nos mercados onde a
       promessa dos portes é verdadeira. Ver o comentário na secção. */
    sub.textContent = !T.limiar ? ''
      : (total >= T.limiar ? T.gratis
                           : (T.faltam || '').replace('{valor}', dinheiro(T.limiar - total)));
    /* A barra é fixa e tapava a última linha da grelha e os ícones de
       pagamento do rodapé. O corpo ganha por baixo a altura que ela ocupa. */
    var ha = unidades > 0;
    selecao.classList.toggle('visivel', ha);
    document.body.classList.toggle('tem-selecao', ha);
    document.body.style.setProperty('--loja-selecao-altura', ha ? selecao.offsetHeight + 'px' : '0px');
  }

  /* O balão do header ATUALIZA-SE SE EXISTIR, E NUNCA SE CRIA.
     A versão anterior criava-o dentro do link do cesto quando não havia nenhum,
     que é o que o `oms-loja.js` no ar também faz. O header desta loja não é o do
     Sense e o link do cesto não é um contentor posicionado, portanto o balão
     escapava para o `.ohm-nav`, que é `fixed`, e a regra do tema
     (`position:absolute; bottom:.8rem; left:2.2rem`) punha-o no canto superior
     esquerdo — por cima do logótipo. Apanhado pelo Júlio a 2026-09-15 num
     iPhone. Injetar elementos num header partilhado a partir de uma folha de
     página é como isto acontece; quem dá o retorno nesta página é a barra da
     seleção, que é visível e diz mais do que um número. */
  function balao(n) {
    document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
      if (n > 0) {
        var s = b.querySelector('span[aria-hidden="true"]');
        if (s) s.textContent = n; else b.textContent = n;
        b.style.display = ''; b.hidden = false;
      } else { b.style.display = 'none'; }
    });
  }

  /* A storefront devolve 429 a pedidos em série, e responde-lhes com uma página
     HTML: um `r.json()` cego rebenta com «Unexpected token '<'». E um 429 não é
     um resultado, é um pedido que não aconteceu — daí a segunda tentativa com
     pausa. Se mesmo assim falhar, a barra fica como estava em vez de se apagar:
     mostrar um carrinho vazio a quem tem lá coisas é pior do que não mexer. */
  function lerCarrinho(tentativa) {
    tentativa = typeof tentativa === 'number' ? tentativa : 0;
    return fetch(T.rota_cart + '.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error('carrinho ' + r.status);
        return r.json();
      })
      .then(function (c) {
        naLoja.clear();
        (c.items || []).forEach(function (i) {
          /* A fotografia vem do próprio carrinho: assim a barra mostra também o
             que já lá estava e não está nesta página — antes, esses saíam como
             um número solto dentro de um quadrado, que se lia como defeito. */
          naLoja.set(i.variant_id, {
            quantidade: i.quantity, chave: i.key, preco: i.final_price || 0,
            imagem: i.image || null, titulo: i.product_title || ''
          });
        });
        /* O que a pessoa acabou de mexer NÃO se sobrepõe com a resposta da loja:
           ela pode estar atrasada em relação ao último toque. Tudo o resto sim. */
        naLoja.forEach(function (l, variante) {
          if (!pendentes.has(variante)) carrinho.set(variante, Object.assign({}, l));
        });
        carrinho.forEach(function (_, variante) {
          if (!naLoja.has(variante) && !pendentes.has(variante)) carrinho.delete(variante);
        });
        marcarTudo();
        pintarLocal();
        document.dispatchEvent(new CustomEvent('oms:cart:updated'));
      })
      .catch(function () {
        if (tentativa < 2) {
          setTimeout(function () { lerCarrinho(tentativa + 1); }, 1500 * (tentativa + 1));
        }
      });
  }

  /* ⚠️ HISTÓRICO, DESATUALIZADO DESDE 2026-09-26. A causa do `null` era a limpeza de
     2026-09-09, que apagou a secção `cart-drawer`; foi reposta, e desde 2026-09-27 a
     gaveta abre ao lado quando um snack entra (evento `oms:carrinho:entrou`, mais abaixo).
     A barra de baixo saiu. Fica o registo do que se pensava:

     A GAVETA DO CARRINHO NÃO SE DEIXA ATUALIZAR, E POR ISSO NÃO SE ABRE AQUI.
     O botão da barra leva ao carrinho, como o ícone do header já faz.

     A primeira versão abria a gaveta, e quem escolhia snacks nesta página
     encontrava-a VAZIA (Júlio, 2026-09-15): ela é desenhada no servidor ao
     carregar a página e o `/cart/add.js` não lhe toca. A cura do Dawn é pedir a
     secção na mesma chamada e trocar o HTML — e aqui não há secção nenhuma para
     pedir. O `layout/theme.liquid` faz `{%- render 'cart-drawer' -%}` a partir de
     `snippets/`, portanto não existe `sections/cart-drawer.liquid` e a API de
     secções devolve `null` para ela, medido a 2026-09-15. O que sobrava era
     puxar a página inteira a cada clique, e isso é caro para dar uma gaveta
     onde uma página serve.

     ⚠️ Isto é do tema e vale para a loja toda: qualquer código que siga o padrão
     do Dawn nesta loja recebe `null` e fica com a gaveta vazia. Está no CLAUDE.md. */

  function enviar(url, corpo) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(corpo)
    }).then(function (r) { return r.json().catch(function () { return {}; }); });
  }

  /* ---------- a escrita, adiada e em fila por snack ----------
     Cada toque adia a escrita em ESPERA milésimos, portanto uma rajada de toques
     dá uma chamada só, com o valor final. Se chegar outro toque enquanto a
     escrita está em curso, fica marcado para repetir no fim: é o que impede duas
     chamadas a correrem ao mesmo tempo sobre a mesma linha e a chegarem
     desordenadas. O `/cart/add.js` SOMA e o `/cart/change.js` FIXA, por isso a
     primeira vez é `add` e as seguintes são `change` — e é `naLoja`, e não o
     estado local, que decide qual é qual. */
  function agendar(variante) {
    var e = pendentes.get(variante) || {};
    clearTimeout(e.adiar);
    e.porEscrever = true;          /* há um toque à espera de ir para a loja */
    e.adiar = setTimeout(function () { escrever(variante); }, ESPERA);
    pendentes.set(variante, e);
  }

  function escrever(variante) {
    var e = pendentes.get(variante) || {};
    if (e.emCurso) { e.repetir = true; pendentes.set(variante, e); return; }
    clearTimeout(e.adiar);
    e.adiar = null;
    e.emCurso = true; e.repetir = false; e.porEscrever = false;
    pendentes.set(variante, e);

    var querida = carrinho.get(variante);
    var n = querida ? querida.quantidade : 0;
    var linha = naLoja.get(variante);
    var pedido = linha
      ? enviar(T.rota_change, { id: linha.chave || variante, quantity: n })
      : (n > 0 ? enviar(T.rota_add, { items: [{ id: variante, quantity: n }] })
               : Promise.resolve({}));

    /* Um snack que entra de novo avisa a gaveta do carrinho, que se abre ao lado
       (`oms-carrinho.js`, decisão do Júlio a 2026-09-27). Só se a loja o aceitar: um
       esgotado volta com `{status, description}` e não abre nada. As mudanças de
       quantidade não abrem; se a gaveta já estiver aberta, ela refresca-se sozinha. */
    var entrou = !linha && n > 0;
    pedido
      .then(function (r) {
        var aceite = entrou && !(r && r.status);
        return lerCarrinho().then(function () {
          if (aceite) document.dispatchEvent(new CustomEvent('oms:carrinho:entrou', { detail: { origem: 'loja', variante: variante } }));
        });
      })
      .catch(function () { return lerCarrinho(); })
      .finally(function () {
        var d = pendentes.get(variante) || {};
        d.emCurso = false;
        /* ⚠️ AQUI ESTAVA O DEFEITO DO «VOLTA A PÔR COMO ESTAVA» (Júlio, 2026-09-15).
           Bastava tocar outra vez enquanto a escrita anterior estava a voltar: o
           `repetir` só ficava marcado se o temporizador já tivesse disparado, e se
           ainda não tivesse, este ramo dava o estado local por assente e escrevia
           por cima dele o que a loja tinha — que era o valor ANTERIOR ao toque. O
           contador saltava para trás e o toque desaparecia. O `porEscrever` fecha
           essa janela: enquanto houver um toque por levar à loja, seja já marcado
           para repetir ou ainda à espera do temporizador, não se toca no que a
           pessoa vê. */
        if (d.repetir || d.porEscrever) {
          pendentes.set(variante, d);
          if (d.repetir) { d.repetir = false; escrever(variante); }
          return;
        }
        pendentes.delete(variante);
        /* Já não há nada por escrever para este snack: o que a loja diz manda. */
        var l = naLoja.get(variante);
        if (l) carrinho.set(variante, Object.assign({}, l)); else carrinho.delete(variante);
        marcarTudo();
        pintarLocal();
      });
  }

  function mudar(ficha, n) {
    var variante = Number(ficha.dataset.variante);
    if (!variante) return;
    n = Math.max(0, Math.min(99, n));
    var actual = carrinho.get(variante) || naLoja.get(variante) || {};
    if (n === 0) carrinho.delete(variante);
    else carrinho.set(variante, {
      quantidade: n, chave: actual.chave, preco: actual.preco,
      imagem: actual.imagem, titulo: actual.titulo
    });
    marcar(ficha, n);     /* o contador responde ao toque, não à rede */
    pintarLocal();
    agendar(variante);
  }

  function quantidade(ficha) {
    var l = carrinho.get(Number(ficha.dataset.variante));
    return l ? l.quantidade : 0;
  }

  raiz.addEventListener('click', function (e) {
    var ficha = e.target.closest('.ficha');
    if (!ficha) return;
    var noCarrinho = quantidade(ficha) > 0;

    if (e.target.closest('[data-juntar]')) {
      e.preventDefault();
      mudar(ficha, aEntrar(ficha));
      ficha.dataset.entrar = 1;        /* o seletor volta a 1 para o próximo snack */
      return;
    }
    if (e.target.closest('[data-mais]')) {
      if (noCarrinho) { mudar(ficha, quantidade(ficha) + 1); }
      else { ficha.dataset.entrar = aEntrar(ficha) + 1; marcar(ficha, 0); }
      return;
    }
    if (e.target.closest('[data-menos]')) {
      if (noCarrinho) { mudar(ficha, Math.max(0, quantidade(ficha) - 1)); }
      else { ficha.dataset.entrar = aEntrar(ficha) - 1; marcar(ficha, 0); }
      return;
    }
  });

  /* Alguém pode mexer no carrinho fora desta página (a gaveta, o header). */
  document.addEventListener('cart:refresh', function () { lerCarrinho(); });
  lerCarrinho();

  /* O resto do catálogo vem depois de a página estar desenhada, não à frente dela. */
  if (window.requestIdleCallback) requestIdleCallback(carregarTudo, { timeout: 2000 });
  else setTimeout(carregarTudo, 500);
})();
